export function getUploadedAssetUrl(apiUrl: string, asset?: string) {
	if (!asset) {
		return undefined;
	}
	if (asset.startsWith("http://") || asset.startsWith("https://")) {
		return asset;
	}
	const apiOrigin = apiUrl.replace(/\/api\/?$/, "").replace(/\/$/, "");
	if (asset.startsWith("/uploads/")) {
		return `${apiOrigin}${asset}`;
	}
	return `${apiOrigin}/uploads/${asset}`;
}
